import React from 'react'
import { Link } from 'react-router-dom'
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import YouTubeIcon from '@material-ui/icons/YouTube';

function Footer() {
    return (
        <div className='footer_container'>
           
            <div className='footer_content'>
                <div className="footercontent_container">
                <h2>Quick Links</h2>
                <Link to="/hoteldeals"> Hotel Deals</Link>
                <Link to="/grouprates"> R F P 's</Link>
                <Link to="/extendedstays"> Extended stay</Link>
                <Link to="/hoteldeals">Meeting space</Link>
                <Link to="/grouprates"> Groups</Link>
                <Link to="/grouprates"> Vacations</Link>              
            

                </div>
                <div className="footercontent_container">
                <h2>Travel</h2>
                <Link to="/grouprates"> Foriegn</Link>
                <Link to="/grouprates"> Local</Link>
                <Link to="/grouprates"> Free Duty</Link>
                <Link to="/grouprates"> Baggage</Link>
                <Link to="/grouprates"> Reservations</Link>
                <Link to="/grouprates"> Bookings</Link>              
            

                </div>
                <div className="footercontent_container">
                <h2>Leisure</h2>
                <Link to="/grouprates"> Family package</Link>
                <Link to="/grouprates"> Reunions</Link>
                <Link to="/grouprates"> Alumni</Link>
                <Link to="/grouprates"> Retreats</Link>
                <Link to="/grouprates"> Fitness</Link>
                <Link to="/grouprates"> Events</Link>              
            

                </div>
                <div className="footercontent_container social">
                <h2>Follow Social</h2>
                <Link to="/grouprates"> <FacebookIcon/> </Link>
                <Link to="www.instagram.com/softwaredev__bytes"> <InstagramIcon /> </Link>
                <Link to="/grouprates"> <LinkedInIcon /> </Link>
                <Link to="/grouprates"> <TwitterIcon /> </Link>
                <Link to="/grouprates"> < YouTubeIcon /> </Link>
                           
            

                </div>
                
                
                
                 </div>

            <div className="hotel_links">
                <a href="https://www.softwaredevbytes.com"> Las Vegas NV Hotel Deals</a>
                <a href="https://www.softwaredevbytes.com"> Orlando FL Hotels</a>
                <a href="https://www.softwaredevbytes.com">Hotels in Chicago IL</a>
                <a href="https://www.softwaredevbytes.com">Hotels in New York City NY</a>
                <a href="https://www.softwaredevbytes.com">Hotels in Miami Beach FL</a>
                <a href="https://www.softwaredevbytes.com">Hotels in Portland OR</a>
                <a href="https://www.softwaredevbytes.com">Hotels in Honolulu HI|</a>
                <a href="https://www.softwaredevbytes.com">Jacksonville FL Hotel Deals|</a>
                <a href="https://www.softwaredevbytes.com">Hotels in Louisville KY|</a>
                <a href="https://www.softwaredevbytes.com">Hotels in Amsterdam Netherlands|</a>
                <a href="https://www.softwaredevbytes.com">Madrid Spain Hotels|</a>
                <a href="https://www.softwaredevbytes.com">Prague Czech Republic Hotel Deals|</a>
                <a href="https://www.softwaredevbytes.com">Hotels in Toronto ON|</a>
                <a href="https://www.softwaredevbytes.com">Austin TX Hotels|</a>
                <a href="https://www.softwaredevbytes.com">Hotels in San Antonio TX|</a>
                <a href="https://www.softwaredevbytes.com">Fort Lauderdale FL Hotel Deals|</a>
                <a href="https://www.softwaredevbytes.com">Dubai United Arab Emirates Hotel Deals|</a>
                <a href="https://www.softwaredevbytes.com">Hotels in Montreal QC|</a>
                <a href="https://www.softwaredevbytes.com">Anaheim CA Hotels|</a>
                <a href="https://www.softwaredevbytes.com">Charlotte NC Hotel Deals|</a>
                <a href="https://www.softwaredevbytes.com">Philadelphia PA Hotel Deals|</a>
                <a href="https://www.softwaredevbytes.com">Paris France Hotel Deals|</a>
                <a href="https://www.softwaredevbytes.com">Hotels in London United Kingdom|
</a>
                <a href="https://www.softwaredevbytes.com">Los Angeles CA Hotels|</a>

            </div>           
        </div>
    )
}

export default Footer
